module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShown) ? _c('overlay', {
    staticClass: "sitemap-overlay"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "sitemap"
  }, [_c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-view col-view-ruyi"
  }, [_c('router-link', {
    staticClass: "sitemap-link sitemap-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".ruyi")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.company-value.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.company-value__our-philosophy.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value__our-philosophy.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.company-value__confucian-roots.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value__confucian-roots.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.company-value__our-staff.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value__our-staff.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.company-value__chairman-message.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value__chairman-message.title')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.talents.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.talents.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.talents__recruitment.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.talents__recruitment.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.talents__talent-development.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.talents__talent-development.title')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.social-responsibility.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.social-responsibility.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.social-responsibility__ruyi-cares.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.social-responsibility__ruyi-cares.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.social-responsibility__ruyi-cares.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.social-responsibility__sustainability.title')))])])])])])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view col-view-technology"
  }, [_c('router-link', {
    staticClass: "sitemap-link sitemap-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".technology")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.rd.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.rd.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.rd__awards-recognitions.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.rd__awards-recognitions.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.rd__ruyi-technology-research-institute.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.rd__ruyi-technology-research-institute.title')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.intelligent-manufacturing.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.intelligent-manufacturing.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.intelligent-manufacturing__eco-textile-spinning-weaving.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.intelligent-manufacturing__eco-textile-spinning-weaving.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.intelligent-manufacturing__intelligent-equipment.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.intelligent-manufacturing__intelligent-equipment.title')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.global-presence.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.global-presence.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.global-presence__textile-in-china.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.global-presence__textile-in-china.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.global-presence__milestones.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.global-presence__milestones.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.global-presence__ruyis_companies.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.global-presence__ruyis_companies.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-view-section d-md-none"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.vertical-integration.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.vertical-integration.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.vertical-integration__whole-wool-spinning-industry-chain.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.vertical-integration__whole-wool-spinning-industry-chain.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.vertical-integration__whole-cotton-spinning-industry-chain.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.vertical-integration__whole-cotton-spinning-industry-chain.title')))])])])])])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view col-view-fashion"
  }, [_c('router-link', {
    staticClass: "sitemap-link sitemap-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-view-section"
  }, [_c('router-link', {
    staticClass: "sitemap-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#ruyi-brand-network'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.text-block-01.title')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view-section"
  }, [_c('router-link', {
    staticClass: "sitemap-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#smcp'
      }
    }
  }, [_vm._v("SMCP")])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view-section"
  }, [_c('router-link', {
    staticClass: "sitemap-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#renown'
      }
    }
  }, [_vm._v("RENOWN")])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view-section d-md-none"
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view col-view-sustainability"
  }, [_c('router-link', {
    staticClass: "sitemap-link sitemap-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-view-section"
  }, [_c('router-link', {
    staticClass: "sitemap-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability"),
        hash: '#green-energy'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-01.title')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view-section"
  }, [_c('router-link', {
    staticClass: "sitemap-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability"),
        hash: '#powering-future'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-02.title')))])], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-primary",
    attrs: {
      "href": _vm.$t('links.ruyi-news.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.ruyi-news.title')))]), _vm._v(" "), _c('a', {
    staticClass: "sitemap-link sitemap-link-primary",
    attrs: {
      "href": _vm.$t('links.contact.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.contact.title')))])])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a10aa57","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Overlays/SitemapOverlay.vue
// module id = 626
// module chunks = 1